/* spx-complemento-ficha — «Complétalo con» bajo el botón de compra de la ficha (25/09/2026).
 *
 * 2ª auditoría multi-modelo: en Simplit el 51% de los pedidos lleva UNA sola línea (421 de 825 en 90
 * días). Bajo «Agregar al carrito» se ofrece un complemento barato, con un botón para sumarlo al carro.
 *
 * Qué se ofrece: el primer RELACIONADO de Shopify (/recommendations) que tenga stock, sea de otro tipo
 * que el producto de la ficha y cueste entre $4.990 y un tercio de su precio (tope $19.990). Si ninguno
 * cumple, no se muestra nada.
 * 28/09/2026 (auditoría «todo todo», T2): si con este producto al carro todavía FALTA para el despacho gratis
 *   (umbral de window.SPX_COMPLETA, que ya carga cada tienda), se elige primero uno que cueste lo que falta o más,
 *   y para eso el tope sube hasta 1,5 veces lo que falta (nunca sobre $19.990). Antes ofrecía un bowl de $9.990
 *   cuando faltaban $10.000 (Simplit Oxford) y una botella de $9.990 cuando faltaban $12.000 (Lhotse Pumori).
 *   Si ninguno alcanza, se ofrece el de siempre.
 *
 * Configuración, antes de cargar el archivo:  window.SPX_COMPLEMENTO = { tema: 'icon' | 'horizon', color: '#2f2f2f' };
 * (25/09, Martin: «el complétalo con para todas las páginas»: Simplit con Icon; Lhotse y unionx.cl con Horizon.)
 * mismaMarca: true → solo de la marca de la ficha. unionx.cl es multimarca: sin esto, a unas barras de techo
 *   XROAD les ofrecía calcetines Lhotse (medido 25/09).  // y unionx.cl no empuja Lhotse ni Simplit
 * 29/09/2026 (Martin, ver el Proyector Flux ofreciendo una pesa: «el complétalo debería ser con un telón»):
 *   COMPLEMENTO FIJO por producto. Si la ficha tiene el metacampo `custom.complemento` (referencia a un
 *   producto), el layout lo deja en window.SPX_COMPLEMENTO_FIJO (handle) y se ofrece ESE, sin tope de precio
 *   ni filtro de tipo, siempre que tenga stock. Si no tiene stock o no existe, sigue la lógica de siempre.
 * 01/10/2026 (pendiente de la sesión del Cyber, Martin «sigamos con lo pendiente»): COMPLEMENTOS CURADOS. Si la ficha
 *   deja window.SPX_COMPLEMENTO_CURADOS (los handles de `custom.complementos_handles`, los mismos del «Comprados juntos»
 *   y del carro «Completa tu compra»), después del FIJO se ofrece el primero de esos con stock que no esté ya en el
 *   carro, sin tope de precio. Así la ficha y el carro conversan. Si no hay, sigue la lógica de siempre.
 *   Con mismaMarca, un curado Lhotse o Simplit solo se ofrece en una ficha de esa marca (19 listas genéricas para 357
 *   fichas: a 7 XROAD les tocaba banano + polera Lhotse).
 * Fuente única: areas/paginas-propias/_comun/tema/spx-complemento-ficha.js
 */
(function () {
  var C = window.SPX_COMPLEMENTO;
  var M = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
  if (!C || !M || window.__spxComplemento) return;
  window.__spxComplemento = 1;

  var fmt = function (c) { return '$' + Math.round(c / 100).toLocaleString('es-CL'); };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (x) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[x]; }); };
  var precio = Math.min.apply(null, (M.variants || []).map(function (v) { return v.price; }).filter(Boolean)) || 0;
  var tope = Math.min(Math.round(precio / 3), 1999000), piso = 499000;
  var FIJO = window.SPX_COMPLEMENTO_FIJO;
  var CUR = window.SPX_COMPLEMENTO_CURADOS; CUR = (CUR && CUR.length) ? CUR : null;
  if (tope < piso && !FIJO && !CUR) return;

  function estilos() {
    var s = document.createElement('style');
    s.textContent =
      '.spx-compl{display:flex;flex:1 0 100%;width:100%;align-items:center;gap:10px;margin:12px 0 4px;padding:10px 12px;border:1px solid #e7e5e4;border-radius:12px;background:#fff;text-align:left;box-sizing:border-box;max-width:100%}' +
      '.spx-compl__img{flex:0 0 52px;width:52px;height:52px;border-radius:8px;object-fit:cover;background:#f5f5f4}' +
      '.spx-compl__info{flex:1 1 auto;min-width:0}' +
      '.spx-compl__tit{font-size:12px;letter-spacing:.02em;color:#6b7280;margin:0 0 2px}' +
      '.spx-compl__nom{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;font-size:13px;line-height:1.3;color:#1f2937;text-decoration:none}' +
      '.spx-compl__precio{margin-top:2px;font-size:13px;font-weight:700;color:#1f2937}' +
      '.spx-compl__precio s{margin-left:6px;font-weight:400;color:#9ca3af}' +
      '.spx-compl .spx-compl__btn{position:static;display:inline-flex;align-items:center;justify-content:center;width:auto;flex:0 0 auto;min-width:84px;height:36px;margin:0;padding:0 12px;text-decoration:none;box-shadow:none;border:1.5px solid var(--spx-c,#2f2f2f);border-radius:18px;background:#fff;color:var(--spx-c,#2f2f2f);font:600 13px/1 inherit;letter-spacing:0;text-transform:none;cursor:pointer}' +
      '.spx-compl .spx-compl__btn:hover{background:var(--spx-c,#2f2f2f);color:#fff}' +
      '.spx-compl .spx-compl__btn[aria-disabled=true]{opacity:.6;pointer-events:none}';
    document.head.appendChild(s);
  }

  function refrescarCarro(items) {
    if (C.tema === 'icon') {
      var el = document.getElementById('cart-config');
      var t = window.Shopify && Shopify.theme;
      if (el && t && t.cart && t.ajaxCart) {
        var cfg = JSON.parse(el.innerHTML || '{}');
        return t.cart.getCart().then(function (c) { t.ajaxCart.updateView(cfg, c); });
      }
      return;
    }
    // Horizon: el evento nativo actualiza contador y cajón (mismo mecanismo que spx-completa-envio.js).
    // 🪤 El import va en un <script type="module"> creado en tiempo de ejecución: el CDN minifica los .js
    // del tema y rompe un import() dinámico.
    var usar = function (m) {
      if (!m || !m.CartLinesUpdateEvent) return;
      var d = m.CartLinesUpdateEvent.createPromise();
      document.dispatchEvent(new m.CartLinesUpdateEvent({ action: 'add', context: 'product',
        lines: items.map(function (i) { return { merchandiseId: String(i.id), quantity: i.quantity }; }), promise: d.promise }));
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
        .then(function (c) { var a = m.CartLinesUpdateEvent.createCartFromAjaxResponse; d.resolve({ cart: a ? a(c) : null, detail: { itemCount: c.item_count } }); })
        .catch(function (e) { d.reject(e); });
    };
    if (window.__lhxEventosShopify) return usar(window.__lhxEventosShopify);
    document.addEventListener('lhx:eventos-shopify', function () { usar(window.__lhxEventosShopify); }, { once: true });
    if (!document.getElementById('lhx-eventos-shopify')) {
      var s = document.createElement('script');
      s.type = 'module';
      s.id = 'lhx-eventos-shopify';
      s.textContent = "import * as m from '@shopify/events'; window.__lhxEventosShopify = m; document.dispatchEvent(new Event('lhx:eventos-shopify'));";
      document.head.appendChild(s);
    }
  }

  function destino() {
    // el formulario de compra de la ficha, no el del cajón ni el de una vista rápida
    var fs = [].filter.call(document.querySelectorAll('form[action*="/cart/add"]'), function (f) {
      // 🪤 no filtrar por [class*=drawer]: en el tema Icon un contenedor de la PÁGINA lleva esa palabra
      return f.querySelector('[name=add], [type=submit]') && !f.closest('#mini-cart, .ajax-cart__drawer-wrapper, .modal, [role=dialog], dialog, product-card, .quick-add') && f.offsetParent !== null;
    });
    // bajo la fila de compra completa (cantidad + botón), si el tema la tiene
    return fs[0] ? (fs[0].closest('.ux-fila-compra') || fs[0]) : null;
  }

  function pintar(p) {
    var f = destino();
    if (!f || document.querySelector('.spx-compl')) return;
    var v = p.variants.filter(function (x) { return x.available; })[0];
    var img = p.featured_image || '';
    if (img && img.indexOf('?') < 0) img += '?width=120';
    var caja = document.createElement('div');
    caja.className = 'spx-compl';
    caja.style.setProperty('--spx-c', C.color || '#2f2f2f');
    caja.innerHTML =
      (img ? '<img class="spx-compl__img" src="' + esc(img) + '" alt="" loading="lazy" width="52" height="52">' : '') +
      '<div class="spx-compl__info"><p class="spx-compl__tit">Complétalo con</p>' +
      '<a class="spx-compl__nom" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
      '<div class="spx-compl__precio">' + fmt(v.price) + (v.compare_at_price > v.price ? '<s>' + fmt(v.compare_at_price) + '</s>' : '') + '</div></div>' +
      '<a href="#" role="button" class="spx-compl__btn" data-spx-variante="' + v.id + '">Agregar</a>';
    // si la ficha está agotada, el «Avísame» (spx-avisame-ficha) va primero, pegado al botón
    var ancla = f.nextElementSibling && f.nextElementSibling.classList.contains('spx-avisa') ? f.nextElementSibling : f;
    ancla.parentNode.insertBefore(caja, ancla.nextSibling);
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.spx-compl__btn');
    if (!b) return;
    e.preventDefault();
    if (b.getAttribute('aria-disabled') === 'true') return;
    b.setAttribute('aria-disabled', 'true'); b.textContent = 'Agregando…';
    var items = [{ id: Number(b.getAttribute('data-spx-variante')), quantity: 1 }];
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () { b.textContent = 'Agregado ✓'; return refrescarCarro(items); })
      .catch(function () { b.removeAttribute('aria-disabled'); b.textContent = 'Agregar'; });
  });

  function iniciar() {
    if (FIJO) {
      return fetch('/products/' + encodeURIComponent(FIJO) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('fijo'); return r.json(); })
        .then(function (p) {
          if (p.id !== M.id && p.variants.some(function (v) { return v.available; })) { estilos(); pintar(p); }
          else throw new Error('sin stock');
        })
        .catch(function () { FIJO = null; if (tope >= piso || CUR) iniciar(); });
    }
    if (CUR) {
      var lista = CUR; CUR = null;
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).catch(function () { return { items: [] }; })
        .then(function (c) {
          var en = {}; (c.items || []).forEach(function (i) { en[i.handle] = 1; });
          return Promise.all(lista.filter(function (h) { return h && !en[h]; }).slice(0, 6).map(function (h) {
            return fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
          }));
        })
        .then(function (ps) {
          var p = (ps || []).filter(function (x) { return x && x.id !== M.id && x.title.indexOf('<Sample>') < 0 && x.variants.some(function (v) { return v.available; }) &&
            // unionx.cl no empuja Lhotse ni Simplit: con mismaMarca, un curado de esas marcas solo va en una ficha de la misma marca
            (!C.mismaMarca || x.vendor === M.vendor || !/^(lhotse|simplit)$/i.test(x.vendor)); })[0];
          if (p) { estilos(); pintar(p); } else if (tope >= piso) iniciar();
        });
    }
    var umbral = window.SPX_COMPLETA && SPX_COMPLETA.umbral;
    var json = function (u) { return fetch(u, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); };
    Promise.all([
      json('/recommendations/products.json?product_id=' + M.id + '&limit=10&intent=related'),
      umbral ? json('/cart.js').catch(function () { return null; }) : null
    ]).then(function (r) {
      var disp = function (x) { return x.variants.filter(function (y) { return y.available; })[0]; };
      var sirve = function (x, max) {
        var v = disp(x);
        return x.id !== M.id && v && x.type !== M.type && v.price >= piso && v.price <= max && x.title.indexOf('<Sample>') < 0 &&
          (!C.mismaMarca || x.vendor === M.vendor);
      };
      var recs = r[0].products || [];
      var cand = recs.filter(function (x) { return sirve(x, tope); });
      // lo que faltaría para el despacho gratis con ESTE producto en el carro (si ya está, no se suma de nuevo)
      var carro = r[1], falta = 0;
      if (umbral && carro) {
        var ya = (carro.items || []).some(function (i) { return i.product_id === M.id; });
        falta = umbral - carro.total_price - (ya ? 0 : precio);
      }
      var topeAlcanza = Math.min(Math.max(tope, Math.round(falta * 1.5)), 1999000);
      var alcanza = falta > 0 ? recs.filter(function (x) { return sirve(x, topeAlcanza) && disp(x).price >= falta; })[0] : null;
      var p = alcanza || cand[0];
      if (p) { estilos(); pintar(p); }
    }).catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
